<template>
  <div class="helmi-commission-agreement-symmary">
    <v-alert
      border="left"
      color="blue-grey"
      text
    >
      <p class="text-h6 ml-2 mb-0 d-flex align-center">
        <v-chip
          class="ml-0 mr-4 black--text"
          color="blue-grey"
          text-color="white"
          small
          v-text="1"
        />
        Kohde
      </p>
      <v-sheet
        flat
        class="text-caption transparent pa-2"
      >
        <div>
          Osoite:
          <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
            {{ property.kohdenimi }}
            <span v-if="osake && property.huoneistonro !== ''">
              {{ property.huoneistonro }}
            </span>
            <span v-if="property.postinumero !== ''">
              {{ property.postinumero }} {{ property.kaupunki }}
            </span>
          </span><br>
          Kohdenumero:
          <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
            {{ property.kohdenumero }}
          </span>
        </div>
      </v-sheet>
    </v-alert>

    <v-alert
      border="left"
      color="blue-grey"
      text
    >
      <p class="text-h6 ml-2 mb-0 d-flex align-center">
        <v-chip
          class="ml-0 mr-4 black--text"
          color="blue-grey"
          text-color="white"
          small
          v-text="2"
        />
        Toimeksiantajat
      </p>
      <v-sheet
        flat
        class="text-caption transparent pa-2"
      >
        <div
          v-for="(seller, index) in sellers"
          :key="index"
          class="mb-2"
        >
          Toimeksiantaja {{ index + 1 }}:
          <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
            {{ seller.nimi }}
            {{ +seller.rooli === 4 ? ' (Kuolinpesä)' : '' }}
          </span>
          <p class="mb-0">
            Henkilötunnus / Y-tunnus:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.sotu }}
            </span>
          </p>
          <p class="mb-0">
            Sähköposti:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.email }}
            </span>
          </p>
          <p class="mb-0">
            Puhelin:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.puhelin }}
            </span>
          </p>
          <p class="mb-0">
            Osoite:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.osoite }}
            </span>
          </p>
          <p class="mb-0">
            Postinumero:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.postinumero }}
            </span>
          </p>
          <p class="mb-0">
            Kaupunki:
            <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
              {{ seller.kaupunki }}
            </span>
          </p>
        </div>
      </v-sheet>
    </v-alert>

    <v-alert
      border="left"
      color="blue-grey"
      text
    >
      <p class="text-h6 ml-2 mb-0 d-flex align-center">
        <v-chip
          class="ml-0 mr-4 black--text"
          color="blue-grey"
          text-color="white"
          small
          v-text="3"
        />
        Välitysliike
      </p>
      <v-sheet
        flat
        class="text-caption transparent pa-2"
      >
        <p
          v-for="(part, key) in company"
          :key="key"
          class="ma-0 text-caption"
        >
          {{ key }}:
          <span class="blue-grey--text text--darken-1 font-weight-bold ml-1">
            {{ part }}
          </span>
        </p>
      </v-sheet>
    </v-alert>

    <v-alert
      border="left"
      color="blue-grey"
      text
    >
      <p class="text-h6 ml-2 mb-0 d-flex align-center">
        <v-chip
          class="ml-0 mr-4 black--text"
          color="blue-grey"
          text-color="white"
          small
          v-text="4"
        />
        Ehdot
      </p>
      <v-sheet
        flat
        class="text-caption transparent pa-2"
      >
        <div class="mb-5">
          <p
            class="ma-0 text-caption"
          >
            Ehdot eritellään lopullisella PDF-dokumentilla.
          </p>
        </div>
      </v-sheet>
    </v-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    property: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({

  }),
  computed: {
    ...mapState({
      commissionAgreements: state => state.commissionAgreement.byId,
      userDetails: state => state.userDetails,
    }),
    id() {
      return +this.$route.params.id;
    },
    sellers() {
      return this.property.sellers.filter(s => +s.rooli !== 5);
    },
    signatures() {
      if (
        this.commissionAgreements
        && this.commissionAgreements[this.id]
        && this.commissionAgreements[this.id].signatures
      ) {
        return this.commissionAgreements[this.id].signatures;
      }
      return [];
    },
    osake() {
      return this.property && +this.property.osakevaikiinteisto > 0;
    },
    company() {
      if (this.property && this.property.companyName) {
        return {
          'Välitysliikkeen rekisteröity toiminimi': this.property.companyName,
          'Välitysliikkeen osoite': this.property.companyAddress,
          'Välitysliikkeen Y-tunnus': this.property.companyVat,
          'Asiaa hoitava henkilö': this.userDetails.nimi,
          Puhelin: this.userDetails.puhelin,
          Sähköposti: this.userDetails.email,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss">
.helmi-commission-agreement-symmary {
  max-width: 1024px;

  .text-h6 {
    font-size: 1.125rem;
    font-weight: bolder;
    letter-spacing: 0.75px;
  }
}
</style>
